import './App.css';

import React from 'react'
import { AppProvider } from './AppProvider'
import { AppRoutes } from './AppRoutes'

function App() {
    
  const touchHandler = (event: any) => {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  };
  document.addEventListener('touchstart', touchHandler, {
    passive: false
  });
  
  return (
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  );
}

export default App;
